import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import { DynamicPhoneNumber } from "services/cms/models/dynamicPhoneNumber";

export interface ResolvedDynamicPhoneNumber {
    isLink: boolean;
    codename: string;
    type: ContentTypeCodenames.DynamicPhoneNumber;
}

const dynamicPhoneNumberResolver = (data: DynamicPhoneNumber): ResolvedDynamicPhoneNumber => {
    return {
        isLink: data.elements.isLink.value[0].codename == "yes",
        codename: data.system.codename,
        type: ContentTypeCodenames.DynamicPhoneNumber,
    };
};

export default dynamicPhoneNumberResolver;
